var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isSearch &&
    _vm.category.level > 2 &&
    _vm.categoryChildren.length > 0
    ? _c(
        "div",
        [
          _c(
            "portal-mobile",
            { attrs: { "portal-to": "category-level-four" } },
            [
              _c("div", { staticClass: "sub-cat-nav__outer" }, [
                _c(
                  "div",
                  { staticClass: "d-none d-lg-block sub-cat-nav__title" },
                  [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("OD3dprimaV2::Template.category")
                        ) +
                          ": " +
                          _vm._s(_vm.category.details[0].name)
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-unstyled sub-cat-nav__list" },
                  _vm._l(_vm.categoryChildren, function (category) {
                    return _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "sub-cat-nav__item",
                          attrs: {
                            href: _vm.getCategoryUrl(category.url),
                            title:
                              category.details[0].metaTitle ||
                              category.details[0].name,
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(category.details[0].name) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }